import { Checkbox, Dialog } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../components/toast/Toast';
import { useDeleteDocuments } from '../../../queries/use-delete-documents';
import { FileRecordNew } from '../../../types/file-record';

type RecordDeleteConfirmProps = {
    fileRecords: FileRecordNew[];
    onClose: () => void;
    onDelete: () => void;
};

function DocumentDeleteConfirm({ fileRecords, onClose, onDelete }: RecordDeleteConfirmProps): JSX.Element | null {
    const [keepReferences, setKeepReferences] = useState(false);

    const deleteDocumentsQuery = useDeleteDocuments();

    function deleteDocument(): void {
        deleteDocumentsQuery.mutate(
            fileRecords.map((record) => ({ id: record.id, keepReferences })),
            {
                onSettled: () => {
                    onDelete();
                    toastNotification('success', 'Document deleted!');
                },
            }
        );
    }

    if (!fileRecords) {
        return null;
    }

    return (
        <Dialog
            isLoading={deleteDocumentsQuery.isLoading}
            isOpen={true}
            description={`Worksheets / Other Schedules that use these files will no longer be reviewed. All references will also be deleted.`}
            primaryAction="Delete"
            secondaryAction="Cancel"
            title={`Delete ${fileRecords.length} file records`}
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={deleteDocument}
        >
            <div className="pb-4">
                <Checkbox
                    disabled={deleteDocumentsQuery.isLoading}
                    label="Keep references as original files. (New copies will be made)"
                    onChange={(e): void => setKeepReferences(e.target.checked)}
                />
            </div>
        </Dialog>
    );
}
export default DocumentDeleteConfirm;
